export enum ActivityType {
 LcmNew = 6000,
 LcmActive = 6001,
 LcmClosed = 6002,
 LcmCancelled = 6003,
 LcmPending = 6004,
 LcmUnassign = 6005,
 LcmChanged = 6006,
 LcmExternalCounselRequest = 6007,
 LcmExternalCounselRequestReject = 6008,
 LcmExternalCounselRequestAccept = 6009,
 LcmAttachFile = 6010,
 LcmTimeLog = 6011,
 LcmCaseNote = 6012,
 LcmInternalMessage = 6013,
 LcmEmail = 6014,
 LcmFutureEvent = 6015,
 OptionMenuEvent = 6016,
}
